import { render, staticRenderFns } from "./AppSubmit.vue?vue&type=template&id=108d08fc&scoped=true&"
import script from "./AppSubmit.vue?vue&type=script&lang=js&"
export * from "./AppSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108d08fc",
  null
  
)

export default component.exports